import type { TemplateRef } from '@angular/core';
import { Directive, HostListener, Optional, SkipSelf, input } from '@angular/core';

import { DropdownComponent } from '../dropdown.component';

@Directive({
  selector: '[targetFor]',
  standalone: true,
})
export class NestedTemplateTriggerDirective {
  public readonly templateRef = input<TemplateRef<any>>(undefined, { alias: 'targetFor' });
  public readonly dropdownRef = input<DropdownComponent>(undefined, {
    alias: 'dropdownComponentRef',
  });

  constructor(@Optional() @SkipSelf() private dropdownComponent: DropdownComponent) {}

  // eslint-disable-next-line ban/ban
  @HostListener('click', ['$event'])
  public setTemplate($event: Event): void {
    $event.preventDefault();
    const dropdownCmp = this.dropdownRef() || this.dropdownComponent;
    const templateRef = this.templateRef();
    if (!templateRef || !dropdownCmp) return;
    dropdownCmp.setNestedTemplate(templateRef);
  }
}
